import React, { useLayoutEffect, useState } from 'react';
import './normalize.css';
import './layout.css';
import 'src/components/typography/typography.css';
import { ScrollControllerProvider } from '@context/ScrollControllerProvider/ScrollControllerProvider';
import { Footer, Header } from '@layout';
import { ButtonVariant } from '@components/Button';
import { JoykitColor, LinkVariant } from '@components/themes';
import { ScrollPosition, trackWindowScroll } from 'react-lazy-load-image-component';
import { FooterNavs } from './FooterNavs';

interface LayoutProps {
  isTransparentHeader?: boolean;
  headerScrollThresholdVh?: number;
  headerRef?: React.RefObject<HTMLElement>;
  transparentJoyLogoColor?: JoykitColor;
  transparentHeaderLinkVariant?: LinkVariant;
  transparentHeaderButtonVariant?: ButtonVariant;
  scrollPosition: ScrollPosition;
  chromeless?: boolean;
  page?: MarcomPageName;
}

const InternalLayout: React.FC<LayoutProps> = ({
  children,
  headerScrollThresholdVh,
  isTransparentHeader = false,
  headerRef,
  transparentJoyLogoColor,
  transparentHeaderLinkVariant,
  transparentHeaderButtonVariant,
  scrollPosition,
  chromeless,
  page,
}) => {
  const [headerScrollThreshold, setHeaderScrollThreshold] = useState<number | undefined>();
  useLayoutEffect(() => {
    if (headerScrollThresholdVh !== undefined) {
      setHeaderScrollThreshold((window.innerHeight * headerScrollThresholdVh) / 100 + 50);
    }
  }, [headerScrollThresholdVh]);
  return (
    <>
      <ScrollControllerProvider scrollPosition={scrollPosition}>
        <>
          {!chromeless ? (
            <Header
              ref={headerRef}
              scrollThreshold={headerScrollThreshold}
              isTransparent={isTransparentHeader}
              transparentJoyLogoColor={transparentJoyLogoColor}
              transparentHeaderLinkVariant={transparentHeaderLinkVariant}
              transparentHeaderButtonVariant={transparentHeaderButtonVariant}
              page={page}
            />
          ) : null}
          <main>
            <FooterNavs />
            {children}
          </main>
          {!chromeless ? <Footer page={page} /> : null}
        </>
      </ScrollControllerProvider>
    </>
  );
};

export const Layout = trackWindowScroll(InternalLayout);
